import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useDialog } from "../contexts/DialogContext";
import { Label } from "@/components/ui/label";
import { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";
import { useAuthProtected } from "../contexts/AuthContext";
import { createNewConversation } from "../data/firestore";
import { useNavigate } from "react-router-dom";
import { placeholders } from "../data/constants";

export function NewConversationDialog() {
  const { currentUser } = useAuthProtected();
  const { isNewConversationOpen, closeNewConversation } = useDialog();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [placeholder, setPlaceholder] = useState(
    placeholders[Math.floor(Math.random() * placeholders.length)],
  );

  useEffect(() => {
    if (isNewConversationOpen) {
      setPlaceholder(
        placeholders[Math.floor(Math.random() * placeholders.length)],
      );
    }
  }, [isNewConversationOpen]);

  const navigate = useNavigate();

  const handleCreateConversation = async () => {
    console.log("Creating conversation with name:", name);
    setLoading(true);
    try {
      const conversationId = await createNewConversation(currentUser.uid, name);
      navigate(`/c/${conversationId}`);
    } catch (error) {
      console.error("Error creating conversation:", error);
      alert("Error creating conversation");
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  const handleClose = () => {
    setName("");
    closeNewConversation();
  };

  return (
    <Dialog open={isNewConversationOpen} onOpenChange={handleClose}>
      <DialogContent
        className="sm:max-w-[425px]"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-left">
            Create new conversation
          </DialogTitle>
          <DialogDescription>
            Enter the name of the person you are speaking to
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="w-full items-center gap-1.5">
            <Label htmlFor="name" className="text-left">
              Name
            </Label>
            <Input
              id="name"
              value={name}
              placeholder={placeholder}
              onChange={(e) => setName(e.target.value)}
              className="placeholder:text-gray-400"
              // autoFocus={false}
              // required
              autoComplete="off"
            />
          </div>
        </div>
        <DialogFooter className="gap-2">
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          {loading ? (
            <Button disabled>
              <Loader2 className="animate-spin" />
              Please wait
            </Button>
          ) : (
            <Button
              type="submit"
              disabled={!name.trim()}
              onClick={handleCreateConversation}
            >
              Create
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
